/**
 * RP → SP3 conversion quota (§8.3).
 * Unified for all accounts: remaining = quota − rp_sp3_converted on user row.
 */
import { USER_LEVELS } from './levels.js';

/** Flat RP→SP3 conversion cap for every member (1:1 with SP3). */
export const RP_SP3_QUOTA_UNIFIED = '9000';

/** @deprecated Use RP_SP3_QUOTA_UNIFIED — kept as alias for older imports. */
export const RP_SP3_QUOTA_DEFAULT = RP_SP3_QUOTA_UNIFIED;

/**
 * @deprecated Per-level map no longer applies; every code resolves to RP_SP3_QUOTA_UNIFIED.
 * Kept so admin/list UIs that iterate levels still show the flat 9000.
 */
export const RP_SP3_QUOTA_BY_LEVEL: Record<string, string> = Object.fromEntries(
  USER_LEVELS.map((l) => [l.code, RP_SP3_QUOTA_UNIFIED]),
);

/** Always returns the unified 9000 quota (level ignored). */
export function resolveRpSp3Quota(_levelCode?: string): string {
  return RP_SP3_QUOTA_UNIFIED;
}

/** All level codes (admin docs / seed loops). */
export const RP_SP3_QUOTA_LEVEL_CODES = USER_LEVELS.map((l) => l.code);
